import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { postAxios } from "../../../util/postAxios";
import * as XLSX from "xlsx";

export const useLiburTahunan = () => {
  const getToken = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;

  const getTim = localStorage.getItem("user");
  const jsonTim = JSON.parse(getTim);

  const [tanggal, setTanggal] = useState(
    moment().utcOffset("+0700").format("YYYY-MM-DD")
  );
  const [isRefresh, setIsRefresh] = useState(false);
  const [listTanggal, setListTanggal] = useState();
  const [pickTanggal, setPickTanggal] = useState("Pilih Tanggal");
  const [listOrang, setListOrang] = useState();

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/liburTahunan`,
      {
        type: "getTanggal",
        tanggal: tanggal,
        tim: jsonTim.tim,
      },
      getToken,
      setListTanggal,
      ""
    );

    setIsRefresh(false);
  }, [isRefresh]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/liburTahunan`,
      {
        type: "getList",
        tanggal: pickTanggal,
        tim: jsonTim.tim,
      },
      getToken,
      setListOrang,
      ""
    );

    setIsRefresh(false);
  }, [isRefresh, pickTanggal]);

  const handleAddTanggalWhitelist = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/liburTahunan`,
        {
          type: "addTanggal",
          date: tanggal,
          tim: jsonTim.tim,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );
      if (response.status === 200) {
        setIsRefresh(true);
        setTanggal(moment().utcOffset("+0700").format("YYYY-MM-DD"));
      }
    } catch (error) {
      return error;
    }
  };

  const handleExportExcel = async () => {
    const filteredDataDibawahSetahun =
      listOrang &&
      listOrang.dibawah.map((obj, index) => {
        return {
          No: index + 1,
          Nama: obj.name,
          Bagian: obj.bagian,
          "Kontrak Awal": obj.kontrakAwal,
          Kepala: obj.kepalaShift,
          "": "",
        };
      });
    const filteredDataDiatasSetahun =
      listOrang &&
      listOrang.setahun.map((obj, index) => {
        return {
          No: index + 1,
          Nama: obj.name,
          Bagian: obj.bagian,
          "Kontrak Awal": obj.kontrakAwal,
          Kepala: obj.kepalaShift,
        };
      });

    const mergeArray = [
      ...filteredDataDibawahSetahun,
      ...filteredDataDiatasSetahun,
    ];

    const workSheet = XLSX.utils.json_to_sheet(mergeArray);
    workSheet["!cols"] = [
      { wch: 4 },
      { wch: 32 },
      { wch: 17 },
      { wch: 12 },
      { wch: 15 },
      { wch: 10 },
      { wch: 4 },
      { wch: 32 },
      { wch: 17 },
      { wch: 12 },
      { wch: 15 },
    ];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "attendance");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workBook, `Libur Tahunan ${pickTanggal}.xlsx`);
  };

  const handleDeleteTanggal = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/deleteTanggalLiburTahunan`,
      {
        date: pickTanggal,
        tim: jsonTim.tim,
      },
      getToken,
      "",
      ""
    );

    setIsRefresh(true);
  };

  return {
    tanggal,
    setTanggal,
    handleAddTanggalWhitelist,
    listTanggal,
    pickTanggal,
    setPickTanggal,
    listOrang,
    handleExportExcel,
    handleDeleteTanggal,
  };
};
